import { render, staticRenderFns } from "./EditAcceptType.vue?vue&type=template&id=7712a2ce&scoped=true&"
import script from "./EditAcceptType.vue?vue&type=script&lang=js&"
export * from "./EditAcceptType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7712a2ce",
  null
  
)

export default component.exports